import { Box, Button, Divider, Paper, Stack, Typography } from '@mui/material';
import { InstallGuide } from '../components/InstallGuide';
import { useAppUpdate } from '../hooks/useAppUpdate';
import { colors, mono } from '../themes/theme';

export function Install() {
    const update = useAppUpdate();

    return (
        <Stack spacing={2}>
            <Box>
                <Typography variant="overline" sx={{ color: colors.muted }}>
                    Add to home screen
                </Typography>
                <Typography variant="h2">Install Pony Up</Typography>
            </Box>
            <InstallGuide />

            <Divider />

            <Paper sx={{ p: 2 }}>
                <Typography variant="overline" sx={{ color: colors.muted }}>
                    Version
                </Typography>
                <Typography
                    sx={{ fontFamily: mono, fontSize: '0.8rem', color: colors.ink, mb: 1.5 }}
                >
                    {update.version}
                </Typography>

                {update.waiting ? (
                    <Button variant="contained" fullWidth onClick={update.apply}>
                        Reload to update
                    </Button>
                ) : (
                    <Stack spacing={1}>
                        <Button
                            variant="outlined"
                            color="inherit"
                            fullWidth
                            disabled={update.checking}
                            onClick={update.checkNow}
                        >
                            {update.checking ? 'Checking…' : 'Check for updates'}
                        </Button>
                        <Typography variant="body2" sx={{ color: colors.muted }}>
                            {update.lastCheckedAt
                                ? `Checked ${update.lastCheckedAt.toLocaleTimeString()} — you're on the latest.`
                                : 'Checked automatically when you open the app.'}
                        </Typography>
                    </Stack>
                )}
            </Paper>
        </Stack>
    );
}
